<template>
<div slot="labels"  class="ui labels">
  <span v-for="option in options">
  <Tag :option="option" :selected="selected"></Tag>
</span>
</div>
</template>

<script>
import { mapMutations } from 'vuex';
import Tag from './Tag.vue';
export default {
  name: 'labels',
  props: ['options', 'selected'],
  components: {Tag}
}
</script>



// WEBPACK FOOTER //
// src/components/Labels.vue